
import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import SocialLinks from './SocialLinks';
import { SITE } from '@/data/site';

function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-semibold text-lg mb-4">Контакти</h3>
            <div className="space-y-3">
              <a href={`tel:${SITE.phoneE164Primary}`} className="flex items-start gap-3 hover:text-primary transition-colors">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <div>{SITE.phonePrimary}</div>
                  <div>{SITE.phoneSecondary}</div>
                </div>
              </a>

              <a href={`mailto:${SITE.email}`} className="flex items-start gap-3 hover:text-primary transition-colors">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{SITE.email}</span>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Адреса</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <a
                  href={SITE.googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-primary transition-colors"
                >
                  {SITE.address}
                </a>
              </div>

              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <div>{SITE.hoursWeekdays}</div>
                  <div>{SITE.hoursSaturday}</div>
                  <div>{SITE.hoursSunday}</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Соціальні мережі</h3>
            <SocialLinks variant="outline" size="default" />
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/70">
            © 2026 {SITE.domain}. Всі права захищені.
          </p>
          <div className="flex gap-4 text-sm">
            <span className="text-white/70 hover:text-white transition-colors cursor-pointer">
              Політика конфіденційності
            </span>
            <span className="text-white/70 hover:text-white transition-colors cursor-pointer">
              Умови використання
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
